import { css } from "styled-components";

export const boxShadowS = css`
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;
export const boxShadowM = css`
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
`;
export const boxShadowL = css`
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
`;
export const boxShadowXL = css`
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
`;
